export function isValidCoordinate(input: string): boolean {
    // Check if the input contains a comma separating latitude and longitude
    const splitIndex = input.indexOf(',')
    if (splitIndex === -1) return false
  
    // Extract latitude and longitude strings
    const latStr = input.substring(0, splitIndex).trim()
    const lonStr = input.substring(splitIndex + 1).trim()
  
    // Parse latitude and longitude as floats
    const Lat = parseFloat(latStr)
    const Lon = parseFloat(lonStr)
  
    // Check if latitude and longitude are valid numbers within geographic bounds
    const isLatValid = !isNaN(Lat) && Lat >= -90 && Lat <= 90
    const isLonValid = !isNaN(Lon) && Lon >= -180 && Lon <= 180
  
    // Return true only if both latitude and longitude are valid
    return isLatValid && isLonValid
  }
  